import React from 'react'
import host_img from '../../images/samantha.jpg'
import line_img from '../../images/lines.png'

import FormOptin from '../FormOptin/FormOptin'
import { T, O } from '../../utils/Typography'
import Line from '../../components/Line/Line'
import ShareBox from '../../components/ShareBox/ShareBox'
import { Link } from '@mui/material'
import Carousel from 'react-material-ui-carousel'

type QuoteProps = {
  text: string
  name: string
}

const Quote = ({ text, name }: QuoteProps) => {
  return (
    <div
      className='Results-single-quote-container'
      style={{ marginLeft: 50, marginRight: 50 }}>
      <p className='Results-quote-img'>“</p>
      <T style={{ fontStyle: 'italic' }}>{text}</T>
      <T style={{ fontWeight: '700', fontSize: 16 }}>{name}​</T>
    </div>
  )
}

const QuoteBox = () => {
  const quotes = [
    {
      text:
        "This content is golden –– so many amazing tips and tricks, and the knowledge I'm gaining as we go through each week is priceless. I'm so much more confident now about starting a podcast than I was before!",
      name: 'Sarah Bowser',
    },
    {
      text:
        "I have learned so much from Sam's expertise. She's thorough, informative, and provides lots of great resources to guide you no matter what level your podcasting experience is.",
      name: 'Michele Napolitan',
    },
    {
      text:
        'To have someone that not only understands podcasting, but is at the top of their game, giving you feedback on your podcast…it’s just invaluable.  I cannot talk more highly of Sam and her academy. Her course is LITERALLY the best!',
      name: 'Jeffrey Vizcaino (Next Song on Deck podcast)',
    },
    {
      text:
        'I have learned so much about podcasting in Sam’s course, from week 1 to the end. I don’t know where I would be without it. I’ve learned and grown so much. Thank you!',
      name: 'Christopher Lopez',
    },
  ]

  return (
    // <Carousel animation='slide'>
    <div>
      {quotes.map(({ text, name }, i) => (
        <Quote key={i} name={name} text={text} />
      ))}
    </div>
    // </Carousel>
  )
}

const ResultsFooter = () => {
  return (
    <div className='Results-footer-container'>
      <br />
      <T variant='h2'>Share Your Style!</T>
      {/* <T>Share your artistic style with your art-friends with <i>#MightCouldBeMyStyle</i> on Instagram!</T> */}
      <ShareBox />
      <br />
      <br />
      <T variant='h3'> Take the Next Step to Create Your Podcast!</T>
      <br />
      <T>
        <Link href='https://www.pineapplepodcasting.com/offers/Ksd2cK2F?coupon_code=STYLEQUIZ'>
          Learn more about Pineapple Podcast Academy here!
        </Link>
      </T>
      <T>
        I created this quiz to give you a jumpstart on starting the podcast
        you've always dreamed of making. Because you just took this quiz, I'm
        offering you a special limited-time discount on our flagship course,
        Pineapple Podcast Academy! Woohoo!
      </T>
      <br />
      <br />
      <T variant='h2' style={{ fontSize: '2.5rem', fontWeight: '700' }}>
        Ready to start YOUR podcast?
      </T>
      <T variant='h4' style={{ marginBottom: '2rem' }}>
        <O>
          Join over 10,000 podcasters getting weekly essays on making podcasts!
        </O>
      </T>
      <FormOptin buttonText='Sign up!' />
      <br />
      <br />
      <Line />
      <br />
      <br />
      <T variant='h2'>Praise for Pineapple Podcast Academy</T>
      <QuoteBox />

      <br />
      <Line />
      <div className='Results-horizontal-flex'>
        <div style={{ flex: 2 }}>
          <img className='Results-host-img' src={host_img} alt='Samantha' />
        </div>
        <div style={{ flex: 3, textAlign: 'left', minWidth: 300 }}>
          <T variant='h3' style={{ marginBottom: '10px' }}>
            Hi, I'm Samantha Lee Wright!
          </T>
          <T style={{ fontSize: 16 }}>
            I’m a podcaster, entrepreneur, mom, wife, and avid karaoke lover.
            Several years ago I decided to start my own podcast, even though I
            had zero experience and a shoestring budget. Through bootstrapping
            and strategizing, I became the world’s top podcaster in my category
            within weeks after launching. My podcast has since reached over 5
            million listens and I’m able to make a living doing what I love
            best—podcasting!
          </T>
          <div style={{ height: 10 }} />
          <T style={{ fontSize: 16 }}>
            I now pour all my experience and expertise into other aspiring
            podcasters in order to help them find success. Join my email list
            below to get even more podcasting help delivered right to your
            inbox.
          </T>
        </div>
      </div>
      <br />
      <T
        variant='h2'
        style={{ fontSize: '2.5rem', fontWeight: '700', marginTop: 10 }}>
        Start your podcast!
      </T>
      <T variant='h4' style={{ marginBottom: '2rem' }}>
        <O>Get more podcast-building resources just like this quiz</O>
      </T>
      <FormOptin buttonText='Sign up!' />
    </div>
  )
}

export default ResultsFooter
